import styled from '@emotion/styled';

export const TextContainer = styled.section`
  background-color: rgba(240, 231, 231, 0.75);
  border-radius: 15px;
  
`;


